const StorageKey = Object.freeze({
  TOKEN: 'token',
  TRACKER: 'tracker',
  SUBSCRIBED: 'subscribed',
})

export default StorageKey